const TOKEN = "token";

const TokenService = {
  get(): string {
    const token = localStorage.getItem(TOKEN);
    return token ? token : "";
  },
  set(value: string) {
    localStorage.setItem(TOKEN, value);
  },
  remove() {
    localStorage.clear();
  },
};

export { TokenService };

export const UsernameService = {
  get(): any {
    const username: any = localStorage.getItem("userdata");
    return username ? JSON.parse(username) : {};
  },
  set(value: any) {
    const userName = value.username.toString().trim().replace('"', '');

    localStorage.setItem("userdata", JSON.stringify(value));
    localStorage.setItem("userName", JSON.stringify(userName));
  },
  remove() {
    localStorage.removeItem("userdata");
  },
};
